import gql from 'graphql-tag'
import { EnumFields } from '..'

export const DealTypeFragment = gql`
  fragment DealType on crm_deal_type {
    ${EnumFields}
  }
`
